export { default } from './LessonInfo';



// WEBPACK FOOTER //
// ./src/components/DataCentre/LessonInfo/index.ts